import { useState } from 'react';
import { toast } from 'sonner';

import { useCreatePet } from '@/features/customers';
import { Button } from '@/shared/ui/Button';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';
import { Input } from '@/shared/ui/Input';

interface QuickPetModalProps {
  customerId: string;
  open: boolean;
  onClose: () => void;
}

export function QuickPetModal({
  customerId,
  open,
  onClose,
}: QuickPetModalProps): JSX.Element | null {
  const createPet = useCreatePet();
  const [name, setName] = useState('');
  const [breed, setBreed] = useState('');

  if (!open) return null;

  const handleSubmit = async () => {
    if (!name.trim()) return;
    try {
      await createPet.mutateAsync({
        customerId,
        name: name.trim(),
        species: 'dog',
        breed: breed.trim() || null,
      });
      toast.success('Pet eklendi');
      onClose();
    } catch {
      toast.error('Pet eklenemedi');
    }
  };

  return (
    <div className="fixed inset-0 z-biz-modal bg-black/40 flex items-center justify-center p-biz-card">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <div>
            <h2 className="text-biz-xl font-bold biz-heading">Hızlı pet ekle</h2>
            <p className="text-biz-sm text-biz-muted-foreground mt-1">
              Müşteri geçmişi ve randevu formunda kullanılacak pet kaydı.
            </p>
          </div>
        </CardHeader>
        <CardBody className="flex flex-col gap-biz-content">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Pet adı" autoFocus />
          <Input value={breed} onChange={(e) => setBreed(e.target.value)} placeholder="Irk / açıklama" />
          <div className="flex justify-end gap-biz-content">
            <Button type="button" intent="secondary" onClick={onClose}>
              Vazgeç
            </Button>
            <Button type="button" onClick={handleSubmit} loading={createPet.isPending}>
              Kaydet
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
